import L from "leaflet";

export const DAKAR_CENTER = [14.7167, -17.4677];

// Pictogrammes SVG (traits type lucide) par profil
const SVG = {
  client: '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
  partner: '<path d="M3 9l1-5h16l1 5"/><path d="M4 9v11h16V9"/><path d="M9 20v-6h6v6"/>',
  courier: '<circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/><path d="M15 6h3l3 7"/><path d="M5.5 17.5L9 9h6l3.5 8.5"/>',
  taxi: '<path d="M5 17h14"/><path d="M6 17V11l2-5h8l2 5v6"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/>',
  artisan: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z"/>',
  dot: '<circle cx="12" cy="12" r="4"/>',
};

export const ROLE_COLORS = {
  client: "#3B82F6",
  partner: "#D4AF37",
  courier: "#22C55E",
  taxi: "#FACC15",
  artisan: "#F97316",
  dot: "#94A3B8",
};

export function roleIcon(role = "client", { size = 40, pulse = false } = {}) {
  const color = ROLE_COLORS[role] || ROLE_COLORS.client;
  const glyph = SVG[role] || SVG.client;
  const halo = pulse
    ? `<span class="woma-marker-pulse" style="position:absolute;inset:0;border-radius:9999px;background:${color};"></span>`
    : "";
  const html = `
    <div style="position:relative;width:${size}px;height:${size}px;">
      ${halo}
      <div style="position:relative;width:${size}px;height:${size}px;border-radius:9999px;background:#0F172A;border:3px solid ${color};display:flex;align-items:center;justify-content:center;box-shadow:0 6px 18px ${color}66;">
        <svg width="${size * 0.5}" height="${size * 0.5}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">${glyph}</svg>
      </div>
    </div>`;
  return L.divIcon({ html, className: "woma-marker", iconSize: [size, size], iconAnchor: [size / 2, size / 2] });
}
